import React from 'react'
import { SHOP_SETTING_KEY } from '../../../const';
import AddProduct from './AddProduct';
import AddProductManagement from './AddOneProductManagement';

function AddProductExcel() {
    //get shop data from localStorage
    const setting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));
    return (
        <>
        {
            setting?.stockInOut ? (
                <AddProductManagement setting={setting} />
            ) : (
                <AddProduct />
            )
        }
        </>
    )
}

export default AddProductExcel